//=require slick-carousel/slick/slick.js
//=require plugins/carousel.js

// Testimonials
$(function() {
    $('.testimonial-carousel').not('.testimonial-carousel--new').each(function() {
        var id = $(this).attr('data-id');
        var testimonials = new Carousel({
            arrows: true,
            dots: false,
            infinite: false,
            fade: true,
            appendArrows: $(this).find('.testimonial-carousel__navigation'),
        }, 'testimonials__content--' + id);
        testimonials.init($('.js-carousel--testimonials__content--' + id));
    })
    $('.testimonial-carousel--new').each(function() {
        var id = $(this).attr('data-id');
        var testimonials = new Carousel({
            arrows: true,
            dots: false,
            infinite: false,
            fade: true,
            appendArrows: $(this).find('.testimonial-carousel__navigation'),
        }, 'testimonials__content--' + id);
        testimonials.init($('.js-carousel--testimonials__content--' + id));
    })
});

// Gallery
$(function() {
    $('.carousel--gallery').each(function() {
        var id = $(this).attr('data-id');
        var gallery = new Carousel({
            arrows: false,
            mobileFirst: true,
            dots: true,
            slidesToShow: 1,
            infinite: false,
            fade: true,
        }, 'gallery--' + id);
        gallery.init($('.js-carousel--gallery--' + id));
    });
});


// Members
$(function() {
    $('.block--team').each(function() {
        var id = $(this).attr('data-block-id');
        if (this.querySelectorAll('.block__item').length > 1) {
            var members = new Carousel({
                mobileFirst: true,
                arrows: false,
                infinite: false,
                dots: false,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 550,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 999,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            infinite: true,
                            arrows: true,
                            appendArrows: $(this).find('.block__navigation'),
                        }
                    }
                ],
            }, 'members__content--' + id);
            members.init($('.js-carousel--members__content--' + id));
        }
    })
});

// Text gallery
$(function() {
    $('.text-gallery').each(function() {
        var id = this.getAttribute('data-id');
        if (this.querySelectorAll('.text-gallery .text-gallery__image').length > 1) {
            var gallery = new Carousel({
                arrows: true,
                mobileFirst: true,
                dots: false,
                slidesToShow: 1,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 999,
                        settings: {
                            slidesToShow: 1.15,
                        }
                    },
                ],
                appendArrows: this.querySelector('.text-gallery__navigation'),
            }, 'text-gallery__gallery--' + id);
            gallery.init($('.js-carousel--text-gallery__gallery--' + id));
        }
    })
});

// Gallery
$(function() {
    $('.block-gallery').each(function() {
        if ($(this).attr('data-carousel')) {
            var id = $(this).attr('data-block-id');

            // Is the carousel changing?
            var changing = false;

            // Before it can change, declare that it is changing
            $('.js-carousel--block-gallery__content--' + id).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                changing = true;
                this.setAttribute('carousel-changing', true);
            });

            // Once it has changed, declare that it is no longer changing
            $('.js-carousel--block-gallery__content--' + id).on('afterChange', function(event, slick, currentSlide, nextSlide){
                changing = false;
                this.removeAttribute('carousel-changing');
            });

            // When the mouse is pressed down, declare that it is changing
            $('.js-carousel--block-gallery__content--' + id).on('mousedown', function(event, slick, direction){
                this.setAttribute('carousel-changing', true);
            });

            // When the mouse is released, and it isn't already changing, declare that it is no longer changing
            $('.js-carousel--block-gallery__content--' + id).on('mouseup', function(event, slick, direction){
                if (!changing) {
                    this.removeAttribute('carousel-changing');
                }
            });

            var gallery = new Carousel({
                arrows: true,
                dots: false,
                appendArrows: $(this).find('.block-gallery__navigation'),
                variableWidth: true
            }, 'block-gallery__content--' + id);

            gallery.init($('.js-carousel--block-gallery__content--' + id));
        }
    })
});

$(function () {
    $('.floorplan-gallery').each(function () {
        if ($(this).attr('data-carousel')) {
            var id = $(this).attr('data-block-id');
            var floorplan = new Carousel({
                arrows: true,
                dots: false,
                appendArrows: $(this).find('.floorplan-gallery__navigation'),
                variableWidth: true,
                infinite: false,
                slidesToShow: 1,
                slidesPerRow: 1,
                centerMode: true,
            }, 'floorplan-gallery__content--' + id);
            floorplan.init($('.js-carousel--floorplan-gallery__content--' + id));
        }
    })
});

// Callouts
$('.block--callouts, .block--member-stories').each(function() {
    var id = $(this).attr('data-block-id');
    var callouts = new Carousel({
        mobileFirst: true,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1.5,
        responsive: [
            {
                breakpoint: 750,
                settings: 'unslick',
            }
        ]
    }, 'callouts--' + id);
    callouts.init($('.js-carousel--callouts--' + id));
})

$('.block--inspiration-carousel').each(function() {
    var id = $(this).attr('data-block-id');
    var callouts = new Carousel({
        mobileFirst: true,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 1.5,
        responsive: [
            {
                breakpoint: 999,
                settings: {
                    slidesToShow: 3,
                    arrows: true
                }
            }
        ],
        appendArrows: $(this).find('.block__navigation')
    }, 'inspiration--' + id);
    callouts.init($('.js-carousel--inspiration--' + id));
})

// Generic block carousel
$(function() {
    $('.block--property-carousel').each(function() {
        var id = $(this).attr('data-block-id');
        var callouts = new Carousel({
            mobileFirst: true,
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1.5,
            responsive: [
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 2.5,
                    }
                },
                {
                    breakpoint: 999,
                    settings: {
                        slidesToShow: 3.25,
                    }
                }
            ],
            appendArrows: $(this).find('.block__navigation'),
        }, 'property-block--' + id);
        callouts.init($('.js-carousel--property-block--' + id));
    })
});

// Generic block carousel
$(function() {
    $('.block--portfolio-carousel').each(function() {
        var id = $(this).attr('data-block-id');
        var callouts = new Carousel({
            mobileFirst: true,
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1.5,
            responsive: [
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 2.5,
                    }
                },
                {
                    breakpoint: 999,
                    settings: {
                        slidesToShow: 2.25,
                    }
                }
            ],
            appendArrows: $(this).find('.block__navigation'),
        }, 'portfolio-block--' + id);
        callouts.init($('.js-carousel--portfolio-block--' + id));
    })
});

$(function() {
    $('.block--member-stories').each(function() {
        var id = $(this).attr('data-block-id');
        var callouts = new Carousel({
            mobileFirst: true,
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1.5,
            responsive: [
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 2.5,
                    }
                },
                {
                    breakpoint: 999,
                    settings: 'unslick'
                }
            ],
            appendArrows: $(this).find('.block__navigation'),
        }, 'member-stories-block--' + id);
        callouts.init($('.js-carousel--member-stories-block--' + id));
    })
});

$(function() {
    $('.block--member-stories-carousel').each(function() {
        var id = $(this).attr('data-block-id');

        $('.js-carousel--member-stories-block--' + id).on('init', (event, slick, currentSlide, nextSlide) => {
            this.dataset.imageItem = 1;
        });

        var callouts = new Carousel({
            mobileFirst: true,
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            appendArrows: $(this).find('.block__navigation'),
        }, 'member-stories-block--' + id);
        callouts.init($('.js-carousel--member-stories-block--' + id));

        $('.js-carousel--member-stories-block--' + id).on('afterChange', (event, slick, currentSlide, nextSlide) => {
            this.dataset.imageItem = currentSlide + 1;
        });
    })
});

$('.carousel--hero').each(function() {
    var id = $(this).attr('data-id');
    var hero = new Carousel({
        arrows: true,
        mobileFirst: true,
        dots: false,
        slidesToShow: 1,
        infinite: false,
        fade: true,
    }, 'hero');
    hero.init($('.js-carousel--hero'));
});

$('.carousel--plain').each(function() {
    var id = $(this).attr('data-id');
    var plain = new Carousel({
        arrows: true,
        mobileFirst: true,
        dots: false,
        slidesToShow: 1,
        infinite: false,
        fade: true,
    }, 'plain');
    plain.init($('.js-carousel--plain'));
});

$('.js-carousel--hero-banners').each(function() {
    var id = $(this).attr('data-id');
    var bannersHero = new Carousel({
        arrows: false,
        mobileFirst: true,
        dots: true,
        slidesToShow: 1,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
    }, 'hero-banners');
    bannersHero.init($('.js-carousel--hero-banners'));
});

// No carousel on mobile
$(function() {
    $('.block--news-carousel').each(function() {
        var id = $(this).attr('data-block-id');
        var callouts = new Carousel({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 2.75,
            responsive: [
                {
                    breakpoint: 999,
                    settings: 'unslick'
                }
            ],
            appendArrows: $(this).find('.block__navigation'),
        }, 'news-block--' + id);
        callouts.init($('.js-carousel--news-block--' + id));
    })
    $('.block--news-carousel-new').each(function() {
        var id = $(this).attr('data-block-id');
        var callouts = new Carousel({
            arrows: true,
            dots: false,
            infinite: false,
            slidesToShow: 2.75,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: 'unslick'
                }
            ],
            appendArrows: $(this).find('.block__navigation'),
        }, 'news-block-new--' + id);
        callouts.init($('.js-carousel--news-block-new--' + id));
    })
});
